import { put, takeLatest, call } from "redux-saga/effects";
import {
	setListNews,
	setDetailNews,
	GetDetailNewsAsyncPayload,
	getListNewsAsync,
	GetListNewsAsyncPayload,
	getDetailNewsAsync,
	CreateMultipleNewsAsyncPayload,
	createMultipleNewsAsync,
	UpdateMultipleNewsAsyncPayload,
	updateMultipleNewsAsync,
	UpdateStatusNewsByGroupCodePayload,
	updateStatusNewsByGroupCodeAsync,
} from "./news.slice";
import { message } from "antd";
import api from "service/apiService";
import { t } from "@lingui/macro";
import { PayloadAction } from "@reduxjs/toolkit";
import { translate } from "utils";

// Get list
function* getListNewsSaga(action: PayloadAction<GetListNewsAsyncPayload>) {
	const { query, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get("/dashboard/news", {
				...query,
				skip: query.skip * query.take,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		yield put({ type: setListNews.type, payload: response });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetListNews() {
	yield takeLatest(getListNewsAsync, getListNewsSaga);
}

// Detail
function* getDetailNewsSaga(action: PayloadAction<GetDetailNewsAsyncPayload>) {
	const { id, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.get(`/dashboard/news/${id}`);
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback?.(response.data.data);
		yield put({ type: setDetailNews.type, payload: response.data });
	} else {
		message.error(translate(error.message));
	}
}
function* watchGetDetailNews() {
	yield takeLatest(getDetailNewsAsync, getDetailNewsSaga);
}

// Create multiple
function* createMultipleNewsSaga(
	action: PayloadAction<CreateMultipleNewsAsyncPayload>,
) {
	const { data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.post("/dashboard/news", { data: data });

			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Create successful`);
	} else {
		message.error(translate(error.message));
	}
}
function* watchCreateMultipleNews() {
	yield takeLatest(createMultipleNewsAsync, createMultipleNewsSaga);
}

// Update multiple
function* updateMultipleNewsSaga(
	action: PayloadAction<UpdateMultipleNewsAsyncPayload>,
) {
	const { data, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.patch("/dashboard/news", { data: data });
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Update successful`);
	} else {
		message.error(translate(error.message));
	}
}
function* watchUpdateMultipleNews() {
	yield takeLatest(updateMultipleNewsAsync, updateMultipleNewsSaga);
}

// Update status by group code
function* updateStatusNewsByGroupCodeSaga(
	action: PayloadAction<UpdateStatusNewsByGroupCodePayload>,
) {
	const { groupCode, status, callback } = action.payload;
	const { response, error } = yield call(async () => {
		try {
			const response = await api.patch(`/dashboard/news/status/${groupCode}`, {
				status,
			});
			return { response };
		} catch (error) {
			return { error };
		}
	});
	if (response) {
		callback && callback();
		message.success(t`Update successful`);
	} else {
		message.error(translate(error.message));
	}
}
function* watchUpdateStatusNewsByGroupCode() {
	yield takeLatest(
		updateStatusNewsByGroupCodeAsync,
		updateStatusNewsByGroupCodeSaga,
	);
}

const customerSaga = [
	watchGetListNews(),
	watchGetDetailNews(),
	watchCreateMultipleNews(),
	watchUpdateMultipleNews(),
	watchUpdateStatusNewsByGroupCode(),
];
export default customerSaga;
